/* eslint-disable @typescript-eslint/naming-convention */
export interface IYeiV3Args {
  args: {
    params: any;
  };
}

export interface IYeiV3Comment {
  created_at: string;
  post_id: string;
  from_id: string;
  id: string;
  message: string;
}

export interface IYeiV3Item {
  can_be_redeemed: boolean;
  created_at: Date;
  description: string;
  id: string;
  image_large_url?: string;
  image_medium_url?: string;
  image_small_url?: string;
  name: string;
  points: number;
  pooling: boolean;
  pooling_contributing_user_ids: [];
  pooling_days_to_go: number;
  pooling_end_time: string;
  visible: boolean;
}

export interface IYeiV3Post {
  created_at: string;
  company_tag: {
    created_at?: Date;
    id?: string;
    name?: string;
    description?: string;
    type?: string;
  };
  skills: {
    id?: string;
    name?: string;
  }[];
  flags: {
    id: string;
    message?: string;
    user_id: string;
  }[];
  from: {
    avatar?: string;
    id: string;
    image30?: string;
    image50?: string;
    image70?: string;
    image160?: string;
    initials?: string;
    job_title: string;
    name: string;
  };
  from_id: string;
  hidden: boolean;
  high_five_ids: string[];
  id: string;
  is_behavior_bonus: boolean | null;
  item?: IYeiV3Item;
  message: string;
  needs_review: boolean;
  points?: number;
  privacy: string;
  properties: object;
  self_reporting_comment: boolean | null;
  self_reporting_comment_truncated: string;
  source: string;
  special_event: boolean | null;
  to_ids: string[];
  type: string;
  url: string;
  comments: IYeiV3Comment[];
}
